import AtriumApi from "api";
import Loader from "components/loader/Loader";
import { useEffect } from "react";
import toast from "react-hot-toast";
import { useNavigate, useSearchParams } from "react-router-dom";

const PCIntegrationRedirecting = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const code = searchParams.get("code");

  useEffect(() => {
    if (code) {
      createPlaningCenterConnection({ code: code });
    }
  }, [code]);

  const createPlaningCenterConnection = async (payload) => {
    try {
      const response = await AtriumApi.post("/v1/access-token", payload);
      if (response) {
        console.log("response", response);
        if (response?.data?.access_token) {
          toast.success("Successfully connected to Planning Center.");
        }
      }
    } catch (error) {
      toast.error("Failed to connect to Planning Center.");
    } finally {
      navigate("/admin/settings?tab=integrations");
    }
  };
  return (
    <div className="flex items-center justify-center py-24">
      <div className="text-center">
        <h1 className="text-3xl font-bold">Redirecting to Planning Center</h1>
        <div className="flex items-center justify-center my-5">
          <Loader />
        </div>
      </div>
    </div>
  );
};

export default PCIntegrationRedirecting;
